import moment from 'moment';
import TIME from '_constants/TIME';

export default (value) => {
  const dayInSeconds = TIME.SECONDS_IN_MIN * TIME.MINUTES_IN_HOUR * TIME.HOURS_IN_DAY;
  if (Number.isNaN(+value)) throw new Error('Invalid value! Expected number');
  if (value >= dayInSeconds) throw new Error('The limit is exceeded');
  return moment().startOf('day').seconds(value).format('HH[h] mm[m]');
};
